import { Search } from "lucide-react";
import { HOME } from "@/constants/testIds";

export default function ResultsHeader({ query, setQuery, onSearch, loading }) {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim()) onSearch(query);
  };

  return (
    <header className="sticky top-0 z-50 glass-header px-3 sm:px-6 py-2.5 sm:py-3">
      <div className="max-w-[1800px] mx-auto flex items-center gap-2 sm:gap-4">
        <button
          onClick={() => window.location.reload()}
          className="shrink-0 cursor-pointer"
        >
          <img src="/favicon.png" alt="ImageScraper" className="w-7 h-7 sm:w-8 sm:h-8 rounded" />
        </button>

        <form data-testid={HOME.searchForm} onSubmit={handleSubmit} className="flex-1 max-w-xl relative group">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/30 group-focus-within:text-[#007AFF] transition-colors" />
          <input
            data-testid={HOME.searchInput}
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Buscar imagens..."
            className="w-full h-9 sm:h-10 pl-9 sm:pl-10 pr-16 sm:pr-20 bg-white/5 border border-white/10 rounded-xl text-sm text-white placeholder:text-white/25 outline-none focus:border-[#007AFF]/50 focus:ring-1 focus:ring-[#007AFF]/20 transition-all"
          />
          <button
            data-testid={HOME.searchButton}
            type="submit"
            disabled={loading || !query.trim()}
            className="absolute right-1.5 sm:right-2 top-1/2 -translate-y-1/2 h-6 sm:h-7 px-3 sm:px-4 bg-[#007AFF] hover:bg-[#007AFF]/90 disabled:opacity-40 text-white text-[11px] sm:text-xs font-semibold rounded-lg transition-all cursor-pointer"
          >
            {loading ? "..." : "Buscar"}
          </button>
        </form>
      </div>
    </header>
  );
}
